var map = {
	"./4250.png": "30XY",
	"./4251.png": "ofO/",
	"./4252.png": "LDba",
	"./4253.png": "CYJD",
	"./4254.png": "dHsD",
	"./4255.png": "3KZH",
	"./4257.png": "cJgU",
	"./4258.png": "5Q1D",
	"./4259.png": "8iNw",
	"./4260.png": "HbKY",
	"./4261.png": "jxoJ",
	"./4262.png": "wWW6",
	"./4263.png": "Gedt",
	"./4265.png": "6CQ7",
	"./4266.png": "FysD",
	"./4269.png": "F+GI",
	"./4270.png": "kQaq",
	"./BumbaLogo.png": "+SZL",
	"./arrowPages.png": "9Zvq",
	"./bernard-hermant-X-Bu9X6gok0-unsplashBackground.jpg": "cYLV",
	"./botonCuentamelo.png": "Px+W",
	"./cabraCSS2.png": "tOqf",
	"./catWalkCycle.png": "NKSm",
	"./favicon.png": "Yhqy",
	"./gatsby-astronaut.png": "qRbu",
	"./gatsby-icon.png": "waaq",
	"./p01_back.jpg": "6DO5",
	"./p01_botonCuentamelo.png": "9mZh",
	"./p01_letrero.png": "bcUi",
	"./p01_letreroPoste.png": "vq6x",
	"./p02_back.jpg": "bGEe",
	"./p02_botonCuentamelo.png": "6zIf",
	"./p02_cencerro.png": "Rx4S",
	"./p02_letrero.png": "B6mn",
	"./p02_letreroPoste.png": "xtC0",
	"./p02_pollito.png": "WDVN",
	"./p03_back.jpg": "DAof",
	"./p03_becerro.png": "wsrs",
	"./p03_becerroCabeza.png": "NMzN",
	"./p03_becerroCola.png": "hlb8",
	"./p03_becerroOrejaDer.png": "U4mO",
	"./p03_becerroOrejaIzq.png": "g77R",
	"./p04_back.jpg": "suAX",
	"./p04_burro.png": "MIeq",
	"./p04_burroCabeza.png": "jlKm",
	"./p04_burroCola.png": "3LR8",
	"./p04_burroColaTip.png": "iI+q",
	"./p04_burroOrejaDer.png": "wLj+",
	"./p04_burroOrejaIzq.png": "0eZa",
	"./p04_burroPataBott.png": "LE7B",
	"./p04_burroPataTop.png": "1lca",
	"./p04_burroTop.png": "9zpT",
	"./p04_cencerroBoton.png": "qheR",
	"./p04_comida.png": "pqbq",
	"./p04_flauta.png": "Y5o7",
	"./p04_nota01.png": "kECr",
	"./p04_nota02.png": "pq+X",
	"./p04_nota03.png": "4Y9S",
	"./p04_nota04.png": "P7SF",
	"./p04_nota05.png": "kCm9",
	"./p04_nota06.png": "BNmO",
	"./p05_back.jpg": "Oc0I",
	"./p05_cencerro.png": "riOB",
	"./p05_gallina.png": "qTdT",
	"./p05_huevo01.png": "aHwW",
	"./p05_huevo02.png": "53cV",
	"./p05_huevo03.png": "QaSo",
	"./p05_huevo04.png": "g1Ef",
	"./p05_huevo05.png": "QflQ",
	"./p05_huevo06.png": "PXxV",
	"./p05_pollito01.png": "2gc0",
	"./p05_pollito01Ala.png": "6Yus",
	"./p05_pollito02.png": "PMBG",
	"./p05_pollito02Ala.png": "Q5Kj",
	"./p05_pollito03.png": "1tmT",
	"./p05_pollito03Ala.png": "u8Yk",
	"./p06_back.jpg": "LqDP",
	"./p06_bocaBott.png": "BgXw",
	"./p06_cencerro.png": "JrRv",
	"./p06_ganso.png": "6YDv",
	"./p06_gansoTop.png": "UzEo",
	"./p06_ocaJuego.png": "kziE",
	"./p07_back.jpg": "0GfG",
	"./p07_borregoL.png": "3BXv",
	"./p07_borregoR.png": "XiCA",
	"./p07_borreguitoL.png": "U9Da",
	"./p07_borreguitoLLegBackLBott.png": "ULXR",
	"./p07_borreguitoLLegBackLTop.png": "BjoP",
	"./p07_borreguitoLLegBackRBott.png": "8g+A",
	"./p07_borreguitoLLegBackRTop.png": "foNc",
	"./p07_borreguitoLLegFrontLBott.png": "FYE2",
	"./p07_borreguitoLLegFrontLTop.png": "QXLP",
	"./p07_borreguitoLLegFrontRTop.png": "DW5m",
	"./p07_borreguitoR.png": "2YBE",
	"./p07_borreguitoRLegBackLBott.png": "FSpk",
	"./p07_borreguitoRLegBackLTop.png": "hJX5",
	"./p07_borreguitoRLegBackRBott.png": "5LCN",
	"./p07_borreguitoRLegBackRTop.png": "djUZ",
	"./p07_borreguitoRLegFrontLBott.png": "XUL/",
	"./p07_borreguitoRLegFrontLTop.png": "e370",
	"./p07_borreguitoRLegFrontRTop.png": "GrKU",
	"./p07_cencerro.png": "ddtV",
	"./p07_sombraBorregos.png": "zMGT",
	"./p07_sombraBorreguitoL.png": "yeHj",
	"./p07_sombraBorreguitoR.png": "SZ9G",
	"./p08_back.jpg": "AGsc",
	"./p08_cencerro.png": "3VyJ",
	"./p08_cerditoBottom.png": "1aX8",
	"./p08_cerditoBottomBoca.png": "VyHy",
	"./p08_cerditoBottomCola.png": "dcfI",
	"./p08_cerditoBottomColaTorcida.png": "9PPT",
	"./p08_cerditoBottomTop.png": "XtAq",
	"./p08_cerditoTop.png": "Bv+H",
	"./p08_cerditoTopCabeza.png": "nG0k",
	"./p08_cerditoTopCola.png": "Tkim",
	"./p08_cerditoTopColaTorcida.png": "l9Vu",
	"./p08_cerditoTopOrejaDer.png": "HYjV",
	"./p08_cerditoTopOrejaIzq.png": "Iuk4",
	"./p08_cerdoGrande.png": "Vb4J",
	"./p08_cerdoGrandeCabeza.png": "xvu2",
	"./p08_cerdoGrandeCola.png": "7Ijg",
	"./p08_cerdoGrandeColaTorcida.png": "ZiMS",
	"./p08_cerdoGrandeOrejaDer.png": "Zw8p",
	"./p08_cerdoGrandeOrejaIzq.png": "A4zD",
	"./p08_cerdoGrandeTop.png": "wYLs",
	"./p08_lodoCerditoTop.png": "8LAJ",
	"./p09_cencerro.png": "wVxG",
	"./p09_pajaroL.png": "fr0x",
	"./p09_pajaroLalaL.png": "cW0F",
	"./p09_pajaroLalaR.png": "HQkQ",
	"./p09_pajaroLvolando.png": "m5Rg",
	"./p09_pajaroLvolandoAlaR.png": "SQJ/",
	"./p09_pajaroR.png": "1T9X",
	"./p09_pajaroRAla.png": "5Kfk",
	"./p09_pajaroRvolando.png": "AkRb",
	"./p09_pajaroRvolandoAlaL.png": "DMfm",
	"./p09_pararoLvolandoAlaL.png": "DV8y",
	"./p09_pararoRvolandoAlaR.png": "Tc7v",
	"./p09_sombraPajaros.jpg": "sQKl",
	"./p10_back.jpg": "YVfX",
	"./p10_cencerro.png": "QvnN",
	"./p10_pastoTop.png": "INoR",
	"./p11_back.jpg": "IpPX",
	"./p11_cencerro.png": "YI4r",
	"./p11_gallo.png": "CvT/",
	"./p11_galloCabeza.png": "t1aY",
	"./p11_galloCola.png": "2+mF",
	"./p11_kikiriki.png": "1cyh",
	"./p11_nota01.png": "FnkT",
	"./p11_nota02.png": "cIMj",
	"./p11_nota03.png": "20xf",
	"./p11_nota04.png": "ZHL8",
	"./p11_nota05.png": "q+a1",
	"./p11_nota06.png": "p9jV",
	"./p11_picoBott.png": "0XZ7",
	"./p11_picoTop.png": "PVzI",
	"./p11_sombraPaja.png": "g9V9",
	"./p12_B_becerroCabeza.png": "TY4a",
	"./p12_C_cencerro.png": "Lfjc",
	"./p12_D_becerroTop.png": "lGNB",
	"./p12_E_becerroCola.png": "ReqJ",
	"./p12_F_becerroCuerpo.png": "CqrH",
	"./p12_G_floresTop.png": "XXVj",
	"./p12_H_vaca.png": "0v/k",
	"./p12_I_sombraVacas.jpg": "Y0TA",
	"./p12_I_sombraVacas.png": "+B4W",
	"./p13_bacerroCabeza.png": "C64k",
	"./p13_back.jpg": "Vn7H",
	"./p13_becerroCollar.png": "RzRC",
	"./p13_becerroOrejaL.png": "X2SN",
	"./p13_becerroOrejaR.png": "Nxtd",
	"./p13_cencerro.png": "atxt",
	"./p13_cencerroCampana.png": "ToaK",
	"./p13_cencerroDing.png": "JET9",
	"./p13_looney.png": "s8uY",
	"./p14_back.jpg": "w1u+",
	"./p14_burrito.png": "5nwT",
	"./p14_cabrita.png": "7s0q",
	"./p14_cerditos.png": "dVe9",
	"./p14_gallinita.png": "aAUT",
	"./p14_gallito.png": "G5Pk",
	"./p14_oquita.png": "h4g7",
	"./p14_ovejitas.png": "hI/p",
	"./p14_pajaritos.png": "vA3B",
	"./resetBoton.png": "aOcK",
	"./resetBotonTrans.png": "Z31V"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "xYzQ";